var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"index"}},[_c('Header',{attrs:{"appName":_vm.appName}}),_c('div',[_vm._v("login status")]),_c('div',[_vm._v("token")]),_c('p',[_vm._v(_vm._s(_vm.token))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }